import React, { FC, memo } from 'react'

import { Loader, ErrorHandler, InterSvgIcon } from 'components'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import {
  ConfirmDialogContent,
  NotificationIcon,
} from '../../styles/DisableAllNotificationsBottomsheet.styles'
import { useDisableAllNotificationsContent } from '../../hooks/useDisableAllNotificationsContent'

export interface DisableAllNotificationsBottomsheetStepOneProps {
  isLoading: boolean
  onConfirm: () => void
  onDismiss: () => void
}

export const DisableAllNotificationsBottomsheetConfirmation: FC<DisableAllNotificationsBottomsheetStepOneProps> =
  memo(({ isLoading, onConfirm, onDismiss }) => {
    const {
      confirmButton,
      details,
      errorOrInactive,
      isAppLoading,
      title,
      traceDetails,
      cancelButton,
      icon,
    } = useDisableAllNotificationsContent({ type: 'confirm' })

    if (isAppLoading) return <Loader />

    if (errorOrInactive) {
      return (
        <ErrorHandler
          traceDetails={traceDetails}
          componentName={DisableAllNotificationsBottomsheetConfirmation.name}
        />
      )
    }

    return (
      <ConfirmDialogContent>
        {icon && (
          <NotificationIcon style={{ backgroundColor: 'var(--alert100)' }}>
            <InterSvgIcon iconRef={icon} width={32} height={32} color="var(--alert500)" />
          </NotificationIcon>
        )}
        <Text variant="headline-h3" semiBold>
          {title}
        </Text>
        <Text variant="body-3">{details}</Text>
        <Button isLoading={isLoading} disabled={isLoading} onClick={onConfirm}>
          {confirmButton}
        </Button>
        <Button variant="secondary" onClick={onDismiss}>
          {cancelButton}
        </Button>
      </ConfirmDialogContent>
    )
  })
